import { useState } from "react";
import { cmsImagePreviewUrl } from "../../../api/cmsImageUrl";
import styles from "./CmsImagePreview.module.css";

export function CmsImagePreview({
  value,
  alt,
  initial = "?",
  size = "medium",
}: {
  value: string;
  alt: string;
  initial?: string;
  size?: "small" | "medium";
}) {
  const src = cmsImagePreviewUrl(value);
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const unavailable = Boolean(value) && (!src || failedUrl === src);
  return (
    <div className={styles.root}>
      {src && !unavailable ? (
        <img
          className={`${styles.image} ${styles[size]}`}
          src={src}
          alt={alt}
          onError={() => setFailedUrl(src)}
        />
      ) : (
        <div
          className={`${styles.fallback} ${styles[size]}`}
          role="img"
          aria-label={unavailable ? `${alt}: photo unavailable` : `${alt}: no photo`}
        >
          {initial}
        </div>
      )}
      {unavailable && <span className={styles.unavailable}>Photo unavailable</span>}
    </div>
  );
}
